import { LiveQueryProvider } from 'next-sanity/preview'

import { client } from '@/cms/client'

export default function PreviewProvider({ children }: { children: React.ReactNode }) {
  return <LiveQueryProvider client={client}>{children}</LiveQueryProvider>
}
